export default __webpack_public_path__ + "static/inline-edit-dont-53fce36c366a1c03d6d307e04ac750d3.png";